import React, { useState } from "react";
import { Grid, TextField, Chip, Box } from "@mui/material";

const KeywordsInput = ({
  keywords,
  onChange,
  onBlur,
  touched,
  error,
  maxKeywords = 10,
  minLength = 2,
  maxLength = 30,
  label = "Business Related Keywords",
  placeholder = "e.g., electronics, organic, wholesale",
}) => {
  const [inputValue, setInputValue] = useState("");
  const [localError, setLocalError] = useState("");

  const validateInput = (value) => {
    const trimmed = value.trim();

    if (trimmed.length < minLength) return `Minimum ${minLength} characters required.`;
    if (trimmed.length > maxLength) return `Maximum ${maxLength} characters allowed.`;
    if (keywords.includes(trimmed)) return "Keyword already exists.";
    if (keywords.length >= maxKeywords) return `You can add up to ${maxKeywords} keywords only.`;

    return "";
  };

  const addKeyword = (value) => {
    const trimmed = value.trim();
    if (!trimmed) return;

    const validationMessage = validateInput(trimmed);
    if (validationMessage) {
      setLocalError(validationMessage);
      return;
    }

    onChange([...keywords, trimmed]);
    setInputValue("");
    setLocalError("");
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    // Split on comma or space
    if (value.includes(",") || value.includes(" ")) {
      const parts = value.split(/[, ]+/).filter(Boolean);
      const validParts = [];

      parts.forEach((part) => {
        const msg = validateInput(part);
        if (!msg) validParts.push(part);
        else setLocalError(msg);
      });

      if (validParts.length > 0) {
        onChange([...keywords, ...validParts]);
      }

      setInputValue(""); // clear field after split
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      e.preventDefault();
      addKeyword(inputValue);
    }
  };

  const handleDeleteKeyword = (keywordToDelete) => {
    onChange(keywords.filter((k) => k !== keywordToDelete));
    setLocalError("");
  };

  return (
    <Grid item xs={12}>
      <TextField
        label={label}
        name="keywords"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onBlur={onBlur}
        fullWidth
        margin="normal"
        placeholder={placeholder}
        error={Boolean(localError || (touched && error))}
        helperText={
          localError ||
          (touched && error) ||
          (!localError && !error && "Type keywords separated by , or space")
        }
      />

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
        {keywords.map((keyword, index) => (
          <Chip
            key={index}
            label={keyword}
            onDelete={() => handleDeleteKeyword(keyword)}
            color="info"
          />
        ))}
      </Box>
    </Grid>
  );
};

export default KeywordsInput;
